import styled from 'styled-components';
import {getColorFromTheme} from '../../../../../../../../ui/ui-utils';
import {Button} from '../../../../../../../../ui/atoms/button';

export const Wrapper = styled.div`
  width: 100%;
  min-width: 0;
`;
export const FreeTrialNotificationDiv = styled.div`
  width: 100%;
  background: ${getColorFromTheme('purple300')};
  color: ${getColorFromTheme('alwaysWhite')};
  padding-top: 8px;
  padding-bottom: 8px;
`;

export const PlansSection = styled.div`
  display: flex;
  width: 100%;
  min-width: 0;
  box-sizing: border-box;
  flex-direction: column;
  align-items: flex-start;
  padding: 24px;
  border: 1px solid ${getColorFromTheme('borderLight')};
  border-radius: 10px;
  background: ${getColorFromTheme('white')};

  @media (max-width: 600px) {
    padding: 20px 16px;
  }
`;
export const PlansDiv = styled.div`
  width: 100%;
  margin-top: 24px;
  display: flex;
  justify-content: flex-start;
`;
export const PlanDiv = styled.div`
  border: 1px solid ${getColorFromTheme('borderLight')};
  border-radius: 12px;
  background-color: ${getColorFromTheme('white')};
  display: flex;
  flex-direction: column;
  gap: 32px;
  width: min(100%, 620px);
  box-sizing: border-box;
  min-width: 0;
  padding: 32px;

  @media (max-width: 500px) {
    gap: 24px;
    padding: 24px 20px;
  }

  .pricingOptions {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 12px;
    margin-top: 24px;

    @media (max-width: 600px) {
      grid-template-columns: 1fr;
    }
  }

  .pricingOption {
    min-width: 0;
    padding: 18px;
    border: 1px solid ${getColorFromTheme('borderLight')};
    border-radius: 10px;
    background: ${getColorFromTheme('backgroundDark')};
  }

  .pricingLabel {
    display: flex;
    min-height: 24px;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
  }

  .savingsBadge {
    flex: 0 0 auto;
    padding: 3px 8px;
    border-radius: 999px;
    background: ${getColorFromTheme('purple100')};
    color: ${getColorFromTheme('purple300')};
    font-size: 12px;
    font-weight: 600;
    line-height: 18px;
  }

  .priceLine {
    display: flex;
    align-items: baseline;
    gap: 6px;
    margin: 12px 0 6px;
  }

  .price {
    font-weight: 600;
    font-size: 32px;
    line-height: 38px;
    color: ${getColorFromTheme('textDark')};
  }

  .priceUnit {
    color: ${getColorFromTheme('textBody')};
    font-size: 13px;
    line-height: 20px;
  }

  .planActions {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  .nextStep {
    margin: 0;
    text-align: center;
  }
`;

export const SeatsDiv = styled.div`
  display: flex;
  width: 100%;
`;

export const SeatDiv = styled.div`
  border: 1px solid ${getColorFromTheme('borderLight')};
  border-radius: 10px;
  background: ${getColorFromTheme('white')};
  width: 100%;
  box-sizing: border-box;
  div.header {
    padding: 18px 16px;
    display: flex;
    align-items: center;
    border-bottom: 1px solid ${getColorFromTheme('borderLight')};
    span {
      margin-right: 10px;
      svg {
        stroke: ${getColorFromTheme('textBody')};
      }
      cursor: pointer;
      &:hover {
        stroke: ${getColorFromTheme('purple300')};
      }
    }
  }
  div.content {
    width: min(100%, 520px);
    box-sizing: border-box;
    padding: 32px 24px 40px;

    @media (max-width: 500px) {
      padding: 28px 16px 32px;
    }
  }
`;

// Billing Cycle Styles
export const BillingCycleOuterWrapper = styled.form`
  min-height: 100%;
  background: ${getColorFromTheme('backgroundLight')};

  .billingBreadcrumb {
    width: min(100%, 1120px);
    margin: 0 auto;
    padding: 0 24px 24px;

    @media (max-width: 600px) {
      padding: 0 16px 20px;
    }
  }
`;
export const BillingCycleInnerWrapper = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1.1fr) minmax(320px, 0.9fr);
  gap: 24px;
  width: 100%;
  max-width: 1120px;
  margin: 0 auto;
  padding: 0 24px 80px;

  .checkoutColumn,
  .summaryColumn {
    display: flex;
    min-width: 0;
    flex-direction: column;
    gap: 20px;
  }

  .summaryColumn {
    position: sticky;
    top: 24px;
    align-self: start;
  }

  .checkoutCard {
    padding: 24px;
    border: 1px solid ${getColorFromTheme('borderLight')};
    border-radius: 12px;
    background: ${getColorFromTheme('white')};
  }

  .address {
    padding: 0;
  }

  @media (max-width: 900px) {
    grid-template-columns: 1fr;

    .summaryColumn {
      position: static;
      grid-row: 1;
    }
  }

  @media (max-width: 600px) {
    padding: 0 16px 48px;

    .checkoutCard {
      padding: 20px 16px;
    }
  }
`;

export const MultiRadioSelectDiv = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;

  div.firstDiv,
  div.secondDiv {
    display: flex;
    min-height: 64px;
    align-items: center;
    justify-content: space-between;
    padding: 16px;
    border: 1px solid ${getColorFromTheme('borderLight')};
    border-radius: 10px;
    background: ${getColorFromTheme('backgroundDark')};
  }

  @media (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`;

export const BillingActionButton = styled(Button)`
  &:disabled {
    border-color: ${getColorFromTheme('backgroundDark')};
    background-color: ${getColorFromTheme('backgroundDark')};
    color: ${getColorFromTheme('textMuted')};
  }
`;
export const PriceBoxDiv = styled.div`
  border: 1px solid ${getColorFromTheme('borderLight')};
  border-radius: 12px;
  overflow: hidden;
  background: ${getColorFromTheme('white')};

  div.top {
    padding: 24px;
    border-bottom: 1px solid ${getColorFromTheme('borderLight')};
  }

  div.bottom {
    padding: 24px;

    div.items {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 22px;
    }
  }
`;
export const PriceHelperInfoDiv = styled.div`
  border: 1px solid ${getColorFromTheme('borderLight')};
  padding: 24px;
  border-radius: 12px;
  background: ${getColorFromTheme('white')};

  div.info {
    display: flex;

    span.price {
      font-weight: 600;
      color: ${getColorFromTheme('textDark')};
    }
  }
`;

export const CardInfoDiv = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  div.expired_cvc {
    display: grid;
    grid-gap: 4%;
    grid-template-columns: 62% 34%;
  }
  div.stripeCard {
    padding: 16px;
    border-radius: 10px;
    border: 1px solid ${getColorFromTheme('borderDark')};
    background: ${getColorFromTheme('white')};
  }
`;
